import React from "react";
import { node } from "prop-types";

const UpdatesPageTemplatePagination = ({ children }) => (
	<div className="updates-page-template__pagination">{children}</div>
);

UpdatesPageTemplatePagination.propTypes = {
	children: node.isRequired,
};

export default UpdatesPageTemplatePagination;
